import React, { forwardRef } from 'react';
import { Checkbox, CheckboxProps, FormControlLabel } from '@material-ui/core';

export const CheckboxLabelled = forwardRef<
  HTMLInputElement,
  CheckboxProps & { label: string }
>((props, ref) => {
  const { label, style, ...rest } = props;

  return (
    <FormControlLabel
      label={label}
      style={style}
      control={<Checkbox color="primary" inputRef={ref} {...rest} />}
    />
  );
});
